import { appColor } from '../../modules/theme';
import {
  LoaderGrow,
  LoaderPulse,
  LoaderRotate,
  LoaderRotateCircle,
  LoaderRotateSVG,
} from './Loader.styles';
import type { Props } from './types';

/**
 * @deprecated
 */
function Loader(props: Props): JSX.Element {
  let output;

  if (props.type === 'rotate') {
    output = (
      <LoaderRotate {...props} data-test-id="loader-rotate">
        <LoaderRotateSVG {...props}>
          <LoaderRotateCircle {...props} cx="50" cy="50" fill="none" r="20" strokeWidth={2} />
        </LoaderRotateSVG>
      </LoaderRotate>
    );
  } else if (props.type === 'pulse') {
    output = (
      <LoaderPulse {...props} data-test-id="loader-pulse">
        <div />
        <div />
      </LoaderPulse>
    );
  } else {
    output = (
      <LoaderGrow {...props} data-test-id="loader-grow">
        <div />
      </LoaderGrow>
    );
  }

  return output;
}

Loader.defaultProps = {
  block: false,
  color: appColor,
  size: 32,
  type: 'grow',
};

export { Loader };
